import React from "react";
import { Sparkles, MessageCircle, CheckCircle2, Award, Users, Star, Trophy } from "lucide-react";
import { Button } from "./ui/button";
import { WHATSAPP_URL } from "../mock";

const Bullet = ({ children }) => (
  <li className="flex items-start gap-3 text-slate-200">
    <CheckCircle2 className="h-5 w-5 text-emerald-400 mt-0.5 flex-shrink-0" />
    <span className="leading-relaxed">{children}</span>
  </li>
);

const Trust = ({ Icon, text }) => (
  <div className="flex items-center gap-2 text-[13.5px] text-slate-300">
    <Icon className="h-4 w-4 text-amber-400" />
    <span>{text}</span>
  </div>
);

const Hero = () => {
  return (
    <section id="top" className="hero-glow relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-32 -left-24 h-[420px] w-[420px] rounded-full bg-amber-500/10 blur-3xl" />
        <div className="absolute top-0 right-0 h-[420px] w-[520px] rounded-full bg-red-500/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 pt-10 md:pt-20 pb-14 md:pb-28 grid lg:grid-cols-[1.05fr_0.95fr] gap-8 lg:gap-14 items-center">
        {/* Left */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 bg-amber-500/10 px-3 py-1 text-[11px] md:text-[11.5px] tracking-[0.18em] uppercase text-amber-300 font-medium">
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
            Limited Time Offer
          </span>

          <h1 className="mt-5 md:mt-6 text-white font-semibold text-[34px] sm:text-[44px] md:text-[64px] leading-[1.05] md:leading-[1.02] tracking-tight">
            <span className="text-amber-400">IELTS / TOEFL / PTE</span>
            <br />
            Exam Fee Cashback
            <br />
            <span className="text-[20px] sm:text-[28px] md:text-[36px] font-normal text-slate-200/95">
              Study in <span className="text-amber-400 font-medium">Australia</span>,{" "}
              United Kingdom or{" "}
              <span className="text-amber-400 font-medium">New Zealand</span>
            </span>
          </h1>

          <p className="mt-5 md:mt-6 text-slate-300 text-[14.5px] md:text-[17px] leading-[1.65] md:leading-[1.7] max-w-xl">
            Already paid for IELTS, PTE, TOEFL or LanguageCert? Get your{" "}
            <span className="text-amber-300">exam fees refunded</span> when
            you enrol for an Australia, UK or New Zealand university through{" "}
            <span className="text-white font-medium">Competitive Careers Pvt Ltd</span>.
            Trusted by 8,000+ students since 2003.
          </p>

          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-2.5 sm:gap-3">
            <Button
              asChild
              className="h-12 px-6 rounded-full bg-red-500 hover:bg-red-600 text-white text-[14.5px] font-medium shadow-lg shadow-red-500/25"
            >
              <a href="#apply" className="inline-flex items-center gap-2">
                <Sparkles className="h-4 w-4" /> Get Cashback
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="h-12 px-6 rounded-full bg-transparent border-white/15 text-white hover:bg-white/5 hover:text-white text-[14.5px]"
            >
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2">
                <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
              </a>
            </Button>
          </div>

          <div className="mt-7 md:mt-8 grid grid-cols-2 md:grid-cols-4 gap-y-3 gap-x-4 md:gap-x-6 max-w-2xl">
            <Trust Icon={CheckCircle2} text="23+ Years Since 2003" />
            <Trust Icon={Users} text="8,000+ Visas Approved" />
            <Trust Icon={Star} text="4.9★ · 1500+ Reviews" />
            <Trust Icon={Trophy} text="Awarded by CM of Gujarat" />
          </div>
        </div>

        {/* Right card */}
        <div className="relative">
          <div className="absolute -inset-0.5 rounded-3xl bg-gradient-to-br from-amber-500/30 via-red-500/10 to-transparent blur-xl opacity-60" />
          <div className="relative rounded-3xl bg-[#0e1626]/90 backdrop-blur border border-white/8 p-6 md:p-7">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-xl bg-amber-500/15 grid place-items-center">
                  <Award className="h-5 w-5 text-amber-400" />
                </div>
                <div>
                  <div className="text-[10.5px] tracking-[0.18em] uppercase text-slate-400">What you get</div>
                  <div className="text-white font-semibold text-[18px]">A complete study-abroad fast track</div>
                </div>
              </div>
              <span className="hidden sm:inline-flex items-center gap-1.5 rounded-full bg-red-500/15 text-red-300 border border-red-500/30 px-2.5 py-1 text-[10.5px] uppercase tracking-[0.16em] font-medium">
                <Sparkles className="h-3 w-3" /> Cashback Offer
              </span>
            </div>

            <ul className="mt-5 space-y-3.5 text-[14.5px]">
              <Bullet>Cashback on your IELTS / PTE / TOEFL / LanguageCert exam fees</Bullet>
              <Bullet>University shortlisting from 600+ partner unis</Bullet>
              <Bullet>Free visa filing · SOP · documents support</Bullet>
              <Bullet>Pre-departure briefing &amp; post-arrival help</Bullet>
              <Bullet>Dedicated counsellor with 23+ years' expertise</Bullet>
            </ul>

            <div className="mt-6 flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.03] p-3.5 pl-4">
              <div>
                <div className="text-[10.5px] tracking-[0.18em] uppercase text-slate-400">Step 1 of 5</div>
                <div className="text-white text-[14.5px]">Fill the 2-minute eligibility form</div>
              </div>
              <Button
                asChild
                className="h-10 rounded-full bg-red-500 hover:bg-red-600 text-white text-[13.5px] px-4"
              >
                <a href="#apply">Start now</a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
